module.exports = __webpack_public_path__ + "img/red_black.ca9a7f1b.png";